export default "2a1044b8e949e1f0.svg"